module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/pre-auth-footer-img-fa0a45d68c165bfcabeb7569058da438.png";